var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48752 4.2344L18.0031 11.2448C18.6708 11.6899 19.0046 11.9125 19.1209 12.193C19.2227 12.4382 19.2227 12.7139 19.1209 12.9591C19.0046 13.2397 18.6708 13.4622 18.0031 13.9073L7.48752 20.9177C6.67946 21.4564 6.27544 21.7258 5.9404 21.7058C5.64852 21.6883 5.37889 21.544 5.20249 21.3108C5 21.0432 5 20.5576 5 19.5864V5.56568C5 4.59452 5 4.10894 5.20249 3.84127C5.37889 3.60808 5.64852 3.46378 5.9404 3.44635C6.27544 3.42635 6.67946 3.6957 7.48752 4.2344Z",
    fill: "url(#paint0_linear_721_3041)",
    stroke: "url(#paint1_linear_721_3041)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_3041",
    x1: -1.5,
    y1: 27.076,
    x2: 20.8114,
    y2: 31.5361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B700FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_721_3041",
    x1: 5,
    y1: 21.576,
    x2: 19.9497,
    y2: 29.8901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B700FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.025641d9c31382db7deff7505acd7cf9.svg";
export { ForwardRef as ReactComponent };